import { defaultCtx } from "~/lib/AjaxCtx"

export default class PresentialService {
    constructor(ctx) {
        this.$http = ctx || defaultCtx
    }

    async pushAttendToEvent(eventId, eventConfirm) {
        return await this.$http.fetchData(
            `/events/${eventId}/changeAttendance`,
            {
                method: "PATCH",
                body: JSON.stringify({ eventConfirm }),
            }
        )
    }

    async attendees(eventId, limit) {
        const url =
            `/events/${eventId}/mates` + (limit ? `?limit=${limit}` : "")
        return await this.$http.fetchData(url)
    }
}
